<template>
  <app-page>
    <div class="content">
      <p>
        一直以来，我们以打造一家值得信赖的能承担社会责任的百年公司为目标，不论是公司，还是公司伙伴，都以惠、敏、恭、信、宽为核心价值观携手前行。
      </p>
      <img src="@/assets/images/about/weal_content_1.png" alt="">
      <p>
        2012年，翡翠王朝建立百分之一爱心俱乐部。杨总倡议公司员工与亲朋好友把每月收入的1%或时间和精力的1%贡献给那些需要帮助的人。截止到2014年9月，百分之一爱心俱乐部已经捐赠了5个小学图书馆，并多次对地震灾区捐款。
      </p>
      <img src="@/assets/images/about/weal_content_2.png" alt="">
      <p>
        2013年，出资为盈江县苏典乡傈僳族勐撇小学捐助学习生活用品；先后为通海县里山中心小学、瑞丽市勐秀乡勐典小学、楚雄市西舍路镇中心小学平山完小等学校捐助德福书屋；为瑞丽市市图书馆捐赠图书；为瑞丽市市妇女儿童发展中心捐赠价值三万元网络技术服务；向昭通市地震灾区、芒海镇泥石流灾区捐款。
      </p>
      <img src="@/assets/images/about/weal_content_3.png" alt="">
      <img src="@/assets/images/about/weal_content_4.png" alt="">
      <p>
        2014年10月，一对大理双胞胎因患脑瘫康复治疗需要巨额款项，发现这对双胞父母在网上的求助信后，翡翠王朝随即拿出多件作品展开爱心义拍，筹集款项捐献给双胞父母。
      </p>
      <img src="@/assets/images/about/weal_content_5.png" alt="">
      <p>
        2014年年底，云南一岁半的女孩小糖果因被确诊为罕见的Rett综合征，若不及时加以复健治疗，她可能永远没法开口说话，迈步行走。从云南日报、云南网等媒体了解到小糖果的故事后，翡翠王朝创始人杨牧仁决定，由公司旗下全媒体平台《玉雕界》向全国玉雕师发出了《玉雕界爱心义拍救助“世纪绝症”患儿征集令》，该活动获得国内玉雕师们踊跃参与，所有款项已经全部汇入云南青基会罕见病患儿基金。
      </p>
      <img src="@/assets/images/about/weal_content_6.png" alt="">
      <p>
        2015年6月1日，经我公司与云南省青少年发展基金会磋商，决定正式筹建云南省青少年发展基金会指导和监管下的“百分之一公益基金”，专门用于资助贫困学生、特殊疾病患儿。
      </p>
      <img src="@/assets/images/about/weal_content_7.png" alt="">
      <p>
        2015年10月27日，翡翠王朝昆明分公司的小伙伴们举行了每月一次的公益活动！并且承诺拿出时间的1%或收入的1%做公益。
      </p>
      <img src="@/assets/images/about/weal_content_8.png" alt="">
      <p>
        翡翠王朝百分之一爱心俱乐部——“让知识改变命运，给大凉山的孩子捐本课外书”暖冬爱心公益活动圆满举办。
      </p>
      <img src="@/assets/images/about/weal_content_9.png" alt="">
      <p>
        “放飞希望.成就梦想”翡翠王朝助学金长期助学项目启动，签约鹿城镇中心小学，辐射周围乡村共11所小学近1500名学生，用来帮助品学兼优的贫困学生顺利完成学业，并激励他们重视知识、努力学习，成为有理想、有道德、有文化、守纪律的优秀学生，通过知识来改变命运。
      </p>
      <img src="@/assets/images/about/weal_content_10.png" alt="">
    </div>
  </app-page>
</template>

<script>
  import AppPage from '../layouts/Main';
    export default {
        name: 'contact',
        components: {
          AppPage
        },
        data() {
            return {

            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped >
  .content{
    padding: 0 0.21rem;
    background-color: rgba(255,255,255,1);
    p{
      text-align: left;
      text-indent: 0.4rem;
      padding: 0.4rem 0 0.13rem 0;
      font-size:0.1867rem;
      color:rgba(2,2,2,1);
      line-height:0.32rem;
      letter-spacing:2px;
    }
  }

</style>
